<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/departamento"> Cadastro/Acesso/Departamentos </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao :active_tab="active_tab" />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Departamento *"
              v-model="descricao"
              :counter="200"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center-left">
          <v-col cols="12" sm="6">
            <v-checkbox
              v-model="requisicao"
              label="Requisição"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6">
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/departamento" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { enviarDepartamentoAsync } from "../../../services/departamentoService";
import { mapState, mapActions } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroUsuario";

export default {
  name: "criarDepartamento",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    requisicao: false,
    active_tab: 2,
  }),
  computed: {
    ...mapState("departamento", ["departamentos"]),
  },
  methods: {
    ...mapActions("departamento", ["addDepartamento"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarDepartamentoAsync(this.descricao, this.requisicao);
        if (
          resposta == null ||
          (resposta.status != null && resposta.status != 200)
        ) {
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.addDepartamento(resposta);
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/departamento");
        }
      }
    },
  },
  components: {
    TabNavegacao,
  },
};
</script>
